import type { routes } from '~/providers/RouterProvider/router.routes';
import type { Params } from '~/providers/RouterProvider/router.types';

import { clientsQueryOptions } from '~/api/clients';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';

export const loader = async ({ params }: { params: Params<typeof routes.editClient> }) => {
  const clients = await queryClient.ensureQueryData(clientsQueryOptions);

  return clients.find((client) => client.id === Number(params.clientId) && !client.deleted) ?? null;
};
